import { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { userService } from 'apiServices';
import memberRoutes from './memberRoutes';
import { Mainlayouts } from 'components';
import SplashContainer from 'containers/SplashContainer';
import LoginContainer from 'containers/LoginContainer';
import RegisterContainer from 'containers/RegisterSystem/RegisterContainer';
import RegisterSuccessContainer from 'containers/RegisterSystem/RegisterSuccessContainer';

const Navigations = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkToken();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const goTo = (pathname) => {
    if (location.pathname === pathname) return;
    navigate({ pathname, search: location.search });
  };

  const checkToken = async () => {
    const token = localStorage.getItem('token');
    const lastSegment = location.pathname.split('/').pop();

    if (!token) {
      if (lastSegment === 'logins') {
        goTo(ROUTE_PATH.LOGIN);
      } else {
        goTo(ROUTE_PATH.SPLASH);
      }
      return;
    }

    const res = await userService.POST_CHECK_TOKEN();
    if (res && res.status === 200) {
      if (lastSegment === 'register') {
        goTo(ROUTE_PATH.SPLASH);
      }
    } else {
      if (lastSegment === 'logins') {
        goTo(ROUTE_PATH.LOGIN);
      } else {
        goTo(ROUTE_PATH.SPLASH);
      }
    }
  };

  return (
    <Routes>
      <Route element={<Mainlayouts.PageLayout />}>
        <Route path={ROUTE_PATH.LOGIN} element={<LoginContainer />} />
        <Route index path={ROUTE_PATH.SPLASH} element={<SplashContainer />} />
        <Route
          path={ROUTE_PATH.REGISTER_SUCCESS}
          element={<RegisterSuccessContainer />}
        />
        <Route path={ROUTE_PATH.REGISTER} element={<RegisterContainer />} />
        <Route path="*" element={<SplashContainer />} />
      </Route>
      <Route
        path={ROUTE_PATH.SYSTEM}
        element={<Mainlayouts.NavigationBottom />}
      >
        {memberRoutes &&
          memberRoutes.map((e, i) => {
            return !e.children ? (
              <Route
                key={i}
                index={e.index}
                path={e.path}
                element={e.element}
              />
            ) : (
              <Route key={i}>
                {e.children &&
                  e.children.map((f, j) => (
                    <Route
                      key={j}
                      index={f.index}
                      path={f.path}
                      element={f.element}
                    />
                  ))}
              </Route>
            );
          })}
      </Route>
    </Routes>
  );
};

export default Navigations;
